import React, { useEffect, useRef, useState, useCallback } from "react";
import { UnSetdataTable } from "../../common/api/setdatatable";
import ProductListGrid from "../../common/productList/productListGrid";
import ProductListTable from "../../common/productList/productListTable";
import { _Api } from "../../common/api/_call";
import NoOrdersYet from "../../common/module/NoOrdersYet/NoOrdersYet";
import Loading from "../../common/module/Loading/Loading";
import { useSelector } from "react-redux";
import { DEFAULT_CATALOG_FILTERS, DEFAULT_ITEM_DATA_SORT } from "./catalogAllFilterUtils";

/**
 * Collection list "All" tab — same listing as `products.js`: `home/itemData` + `ProductListGrid`.
 */
const CatalogAllProducts = ({
  Optiondetails,
  customer,
  parkid,
  order_id,
  order_edit,
  order_type,
  catalogNavId,
  itemId = "",
  categoryId = "",
  itemName = "",
  setShowcheckout,
  setUpdatedCart,
  setsearchproductstatus,
  saleFilter = "top_sale",
  productFilters,
  isListView = false,
  productsReady = true,
}) => {
  const scrollableDivRef = useRef(null);
  const queryKeyRef = useRef('');
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [skip, setSkip] = useState(0);
  const Sale = saleFilter;
  const [Totalproduct, setTotalproduct] = useState(0);
  const [Loadingstatus, setLoadingstatus] = useState(false);
  const [shoremorelodar, setShowmorelodar] = useState(false);
  const [hasReachedEnd, setHasReachedEnd] = useState(false);
  const [addparmission, setAddparmission] = useState(0);
  const [productlist, setProductlist] = useState();
  const [custom_data, setCustom_data] = useState();
  const [finalprodata, setFinalprodata] = useState([]);
  const [uuid, setUuid] = useState("");
  const [cartstockid, setStockid] = useState();
  const [inv_orderid, setInv_orderid] = useState();
  const [inv_ordertype, setInv_ordertype] = useState();
  const [by_repair_order, setBy_repair_order] = useState();
  const [by_customorder, setBy_customorder] = useState();

  useEffect(() => {
    if (parmissiondatashow?.POS?.View || parmissiondatashow?.WishList?.View)
      setAddparmission(parmissiondatashow?.POS?.Add);
  }, [parmissiondatashow]);

  const filterIsCatalog = Optiondetails === true;

  const queryKey = JSON.stringify({
    Sale,
    filterIsCatalog,
    customerId: customer?.id,
    productFilters,
    itemId,
    categoryId,
  });

  const resolveItemDataFilterIds = () => {
    const filters = productFilters || {};
    const itemIds = [...(filters.item || [])];
    const collectionIds = [...(filters.collection || [])];
    const styleIds = [...(filters.style || [])];

    // Only fall back to the navigated subcategory when nothing is selected in filters.
    if (categoryId === 'Item' && itemIds.length === 0 && itemId) {
      itemIds.push(itemId);
    } else if (
      categoryId === 'Collection' &&
      collectionIds.length === 0 &&
      itemId
    ) {
      collectionIds.push(itemId);
    } else if (
      categoryId === 'Style' &&
      styleIds.length === 0 &&
      itemId
    ) {
      styleIds.push(itemId);
    }

    return { itemIds, collectionIds, styleIds };
  };

  const getproducts = useCallback(async () => {
    const { itemIds, collectionIds, styleIds } = resolveItemDataFilterIds();
    if (
      categoryId &&
      !itemIds.length &&
      !collectionIds.length &&
      !styleIds.length
    ) {
      return;
    }
    UnSetdataTable("pos_order_table");
    if (!shoremorelodar) {
      setLoadingstatus(true);
    }
    try {
      const filters = productFilters || {};
      const postdata = {
        type: filterIsCatalog ? "catalog" : "inventory",
        limit: 20,
        skip,
        sale: Sale,
        sort: filters.sortBy || DEFAULT_ITEM_DATA_SORT,
        search: "",
        category_id: categoryId || "",
        customer_id: customer?.id ? customer.id : "",
        item: itemIds,
        collection: collectionIds,
        style: styleIds,
        metal: filters.metal?.length ? filters.metal : [],
        stone: filters.stone?.length ? filters.stone : [],
        size: filters.size?.length ? filters.size : [],
        status: filters.status?.length ? filters.status : [],
        ...(filters.price?.length === 2
          ? { min_price: filters.price[0], max_price: filters.price[1] }
          : {}),
      };
      localStorage.setItem("itemdata", JSON.stringify(postdata));
      let res = await _Api(postdata, `api/v1/POS/home/itemData`);
      if (res.code === 200) {
        if (res?.data?.length || res?.soldOutOrder?.length) {
          if (skip === 0) {
            const sold = res?.soldOutOrder || [];
            const rows = res?.data || [];
            setCustom_data(res?.soldOutOrder);
            setFinalprodata([...sold, ...rows]);
            setProductlist(rows);
          } else {
            setCustom_data((prev) => [
              ...(prev || []),
              ...(res?.soldOutOrder || []),
            ]);
            setProductlist((prev) => [...(prev || []), ...(res?.data || [])]);
            setFinalprodata((prev) => [
              ...prev,
              ...(res?.soldOutOrder || []),
              ...(res?.data || []),
            ]);
          }
        } else {
          setProductlist([]);
          setFinalprodata([]);
          setCustom_data([]);
        }
        setTotalproduct(res?.total);
        if (shoremorelodar) {
          setShowmorelodar(false);
        } else {
          setLoadingstatus(false);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, Sale, filterIsCatalog, customer?.id, productFilters, itemId, categoryId]);

  const handleScroll = () => {
    if (shoremorelodar) return;
    const div = scrollableDivRef.current;
    if (!div) return;
    const { scrollTop, scrollHeight, clientHeight } = div;
    const CompleteScroll = scrollTop + clientHeight;
    if (CompleteScroll >= scrollHeight - 5) {
      if (!hasReachedEnd) {
        if (
          finalprodata?.length !== 0 &&
          skip + 20 < Totalproduct &&
          shoremorelodar === false
        ) {
          setHasReachedEnd(true);
          setSkip((prevSkip) => prevSkip + 20);
          setShowmorelodar((prev) => (prev ? false : true));
        }
      }
    } else {
      setHasReachedEnd(false);
      setShowmorelodar(false);
    }
  };

  useEffect(() => {
    if (!productsReady) {
      queryKeyRef.current = '';
      return;
    }

    const queryChanged = queryKeyRef.current !== queryKey;
    if (queryChanged) {
      queryKeyRef.current = queryKey;
      if (skip !== 0) {
        setSkip(0);
        setProductlist(undefined);
        setCustom_data(undefined);
        setFinalprodata([]);
        setShowmorelodar(false);
        setHasReachedEnd(false);
        return;
      }
      setProductlist(undefined);
      setCustom_data(undefined);
      setFinalprodata([]);
      setShowmorelodar(false);
      setHasReachedEnd(false);
    }

    getproducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryKey, skip, productsReady]);

  const {
    itemIds: resolvedItemIds,
    collectionIds: resolvedCollectionIds,
    styleIds: resolvedStyleIds,
  } = resolveItemDataFilterIds();
  const showSubCategoryEmptyState =
    categoryId &&
    !resolvedItemIds.length &&
    !resolvedCollectionIds.length &&
    !resolvedStyleIds.length;

  return (
    <>
      <div
        className="catalog-all-products-inner bg-white h-100 overflow-auto"
        ref={scrollableDivRef}
        onScroll={handleScroll}
      >
        {custom_data?.length ||
        (productlist?.length && Loadingstatus === false) ? (
          isListView ? (
            <ProductListTable
              ProductListTable={productlist}
              setProductListTable={setProductlist}
              filter={filterIsCatalog}
              setShowcheckout={setShowcheckout}
              itemid={itemId || ""}
              NavId={catalogNavId ?? categoryId ?? ""}
              itemname={itemName || ""}
              setsearchproductstatus={setsearchproductstatus}
              setUpdatedCart={setUpdatedCart}
              parkid={parkid}
              order_id={order_id}
              order_edit={order_edit}
              order_type={order_type}
              customer_id={customer?.id}
              setInv_orderid={setInv_orderid}
              inv_orderid={inv_orderid}
              setInv_ordertype={setInv_ordertype}
              inv_ordertype={inv_ordertype}
              setBy_customorder={setBy_customorder}
              by_customorder={by_customorder}
              setBy_repair_order={setBy_repair_order}
              by_repair_order={by_repair_order}
              addparmission={addparmission}
              finalprodata={finalprodata}
              setUuid={setUuid}
              uuid={uuid}
              cartstockid={cartstockid}
              setStockid={setStockid}
            />
          ) : (
            <ProductListGrid
              ProductListGrid={productlist}
              setProductListGrid={setProductlist}
              filter={filterIsCatalog}
              setShowcheckout={setShowcheckout}
              itemid={itemId || ""}
              NavId={catalogNavId ?? categoryId ?? ""}
              itemname={itemName || ""}
              setsearchproductstatus={setsearchproductstatus}
              parkid={parkid}
              order_id={order_id}
              setUpdatedCart={setUpdatedCart}
              order_edit={order_edit}
              order_type={order_type}
              setInv_orderid={setInv_orderid}
              inv_orderid={inv_orderid}
              setInv_ordertype={setInv_ordertype}
              setBy_repair_order={setBy_repair_order}
              inv_ordertype={inv_ordertype}
              by_repair_order={by_repair_order}
              by_customorder={by_customorder}
              setBy_customorder={setBy_customorder}
              addparmission={addparmission}
              custom_data={custom_data}
              finalprodata={finalprodata}
              setUuid={setUuid}
              uuid={uuid}
              cartstockid={cartstockid}
              setStockid={setStockid}
            />
          )
        ) : showSubCategoryEmptyState ? (
          <NoOrdersYet />
        ) : Array.isArray(productlist) && productlist.length === 0 ? (
          <NoOrdersYet />
        ) : (
          <Loading />
        )}
      </div>
      {shoremorelodar ? (
        <div
          className="border-bottom-0 d-block main-green-text mx-auto my-4 spinner-border flex-shrink-0"
          role="status"
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CatalogAllProducts;
